import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface HeroSectionProps {
  onScrollToTimeline: () => void;
}

const HeroSection = ({ onScrollToTimeline }: HeroSectionProps) => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-primary to-secondary text-white overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-secondary rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-4 py-16 lg:py-24 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Icon name="DocumentTextIcon" size={20} className="text-accent" />
            <span className="text-sm font-medium">Živý dokument, který roste s vámi</span>
          </div>
          
          <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold mb-6 font-headline">
            Finanční plán, který se vyvíjí s vaším životem
          </h1>
          
          <p className="text-lg lg:text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            Zapomeňte na statické dokumenty, které po měsíci zastarají. Náš přístup k finančnímu plánování je založen na partnerství, kde váš plán žije, dýchá a přizpůsobuje se každé změně ve vašem životě.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              href="/online-initial-diagnosis"
              className="w-full sm:w-auto px-8 py-4 bg-accent text-accent-foreground font-semibold rounded-lg hover:bg-accent/90 hover:shadow-hover hover:scale-105 transition-smooth flex items-center justify-center space-x-2"
            >
              <span>Začít s diagnózou</span>
              <Icon name="ArrowRightIcon" size={20} className="text-current" />
            </Link>
            
            <button
              onClick={onScrollToTimeline}
              className="w-full sm:w-auto px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/20 transition-smooth flex items-center justify-center space-x-2"
            >
              <span>Jak to funguje</span>
              <Icon name="ChevronDownIcon" size={20} className="text-current" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;